import React, { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { fetchMerchandisingSummary } from "../api/MerchandisingAPIs";
import { useAuth } from "../utils/auth";
import { isAdmin } from "../utils/roles";

const MerchandisingReportPage = () => {
  const navigate = useNavigate();
  const { authState } = useAuth();
  const canView = isAdmin(authState.role);
  useEffect(() => {
    if (!canView) navigate("/dashboard");
  }, [canView, navigate]);
  const { data, isLoading, isError } = useQuery({
    queryKey: ["merchandising-summary"],
    queryFn: () => fetchMerchandisingSummary(30),
    enabled: canView,
  });

  if (!canView) return null;

  return (
    <div className="min-h-screen bg-slate-50 p-4 md:p-8" dir="rtl">
      <div className="mb-6 flex items-center justify-between gap-4">
        <h1 className="text-3xl font-bold text-slate-900">مجموعات وباقات — آخر 30 يوماً</h1>
        <button
          type="button"
          onClick={() => navigate("/dashboard")}
          className="inline-flex shrink-0 items-center gap-2 rounded-2xl border border-slate-200 bg-white px-8 py-4 text-xl font-bold text-slate-800 shadow-md hover:bg-slate-100"
        >
          <ChevronRight size={28} />
          رجوع
        </button>
      </div>
      <p className="mb-4 text-sm text-slate-500">الأحداث والمبيعات المحفوظة. الشحن المجاني يظهر كخصم شحن منفصل عن إيراد الباقة.</p>
      {isLoading && <p>جاري التحميل...</p>}
      {isError && <p className="text-red-600">تعذر تحميل التقرير.</p>}
      {data && (
        <div className="grid gap-4 lg:grid-cols-2">
          <section className="rounded-2xl bg-white p-4">
            <h2 className="mb-2 font-bold">الأحداث</h2>
            <ul className="space-y-1 text-sm">
              {(data.events || []).map((row) => (
                <li key={`${row.eventName}-${row.subjectType}-${row.subjectId}`}>
                  {row.eventName} · {row.subjectType} #{row.subjectId || "—"} · {row.count}
                </li>
              ))}
              {(data.events || []).length === 0 && <li>لا توجد أحداث بعد.</li>}
            </ul>
          </section>
          <section className="rounded-2xl bg-white p-4">
            <h2 className="mb-2 font-bold">مبيعات الباقات</h2>
            <ul className="space-y-2 text-sm">
              {(data.bundleSales || []).map((row) => (
                <li key={`${row.catalogBundleId}-${row.bundleName}`}>
                  <p className="font-semibold">{row.bundleName}</p>
                  <p>طلبات {row.orders} · إيراد {row.revenue} · خصم {row.discount} · هدايا {row.giftValue} · خصم شحن {row.shippingDiscount}</p>
                </li>
              ))}
              {(data.bundleSales || []).length === 0 && <li>لا توجد مبيعات باقات في هذه الفترة.</li>}
            </ul>
          </section>
        </div>
      )}
    </div>
  );
};

export default MerchandisingReportPage;
